import { ResponseError } from '@/gen/ecom/runtime'
import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'

import type { z } from 'zod'

type ErrorWithSubjectAndMessage = {
  subject?: string
  message?: string
}

export const parseResponseErrorWithSchema = async <TSchema extends z.ZodTypeAny>(
  error: unknown,
  schema: TSchema,
  zodCatch: typeof defaultZodCatch = defaultZodCatch
): Promise<z.infer<TSchema> | undefined> => {
  if (!(error instanceof ResponseError)) {
    return undefined
  }

  const body = await error.response
    .clone()
    .json()
    .catch(() => undefined)

  return schema.catch(zodCatch).parse(body)
}

export const getErrorTextFromSubjectAndMessage = (error?: ErrorWithSubjectAndMessage): string | undefined => {
  const subject = error?.subject?.trim()
  const message = error?.message?.trim()
  const errorText = [subject, message].filter(Boolean).join(': ')

  return errorText || undefined
}
